import { Injectable } from '@angular/core';
import moment from 'moment';;
import { Utils } from "axis-ui-generator";
import { CHECKBOXHEADINGLITETravel, CHECKBOXLITEBAG, CHECKBOXLITEPERSONAL, countriesWithoutHospitalDoctoreSection, countrySpecificPA, isFractureNotRequired, timeFormatSpecificCountries } from 'src/app/features/fnol/config/fnol-constants';
import { AxisInputNumberPipe } from "axis-components";
import { DataStoreService } from "src/app/features/fnol/services/data-store.service";
import { FnolService } from "src/app/features/fnol/services/fnol.service";
import { CacheService } from 'src/app/shared/services/cache.service';
import { countrySpecificHeadings,countrySpecificAMR } from 'src/app/features/fnol/config/fnol-constants';
import { CURRENCYFORMAT } from 'src/app/features/fnol/config/fnol-constants';
import { ActivatedRoute} from '@angular/router';
import { inject} from '@angular/core';



@Injectable({
  providedIn: 'root'
})
export class ClaimtypeBenefittypeAbstractService {

  momentDateFormat = 'DD-MM-YYYY';
  uiStructure;
  step2 = 'fnol-claimtype-details';
  personalAccident = [];
  mySettings51: any = {
    view_roundoff: false,
    thousands_separator: CURRENCYFORMAT[window.location.pathname.split('/')[2]] ? '.' : ',',
    decimal_separator:CURRENCYFORMAT[window.location.pathname.split('/')[2]] ? ',' : '.',
    fraction_size: '2',
    decimal: '',
    restrict: false
  };

  constructor(
    public dataStoreService: DataStoreService, public axisPipe: AxisInputNumberPipe, public fnolService: FnolService, public cacheService: CacheService) {
  }

  /**
   *
   * @param name field label from Json
   * @param type Label /uiData
   * @param stepName step name
   * @returns
   */
  getData(name, type, stepName) {
    let resultData;
    this.uiStructure = this.dataStoreService.get(stepName).uiStructure;
    const uiData = this.dataStoreService.get(stepName).uiData;
    const translations = this.cacheService.getTranslation();
    try {
      resultData = Utils.getFieldFromStructure(this.uiStructure, name);
    }
    catch (error) {
      resultData = '';
      return resultData;
    }
    if (type === 'label') {
      if (!resultData) {
        return '';
      }
      if (resultData?.type === 'checkbox') {
        return {
          key: resultData?.heading,
          value: resultData?.questionCd,
        }
      }
      if (translations) {
        resultData.label = translations[resultData.label] ? translations[resultData.label] : resultData.label;
      }
      return resultData;
    }
    else {
      if (resultData?.type === "datepicker" && uiData[name] !== 'Invalid date' && uiData[name] !== null && uiData[name] !== '') {
        return (uiData[name] !== null && uiData[name] !== "") ? moment(new Date(uiData[name])).format(this.momentDateFormat) : uiData[name];
      } else if (resultData?.type === "timepicker") {
        const timeFormat = timeFormatSpecificCountries[this.cacheService.getCountry()] ? 'HH:mm' : 'hh:mm A';
        return (uiData[name] !== null && uiData[name] !== "") && uiData[name]?.length > 5 ? moment(uiData[name]).format(timeFormat) : uiData[name];
      } else if (resultData?.type === "checkbox") {
        return (uiData[name] !== null && uiData[name] !== '' && uiData[name] !== 'No') ? $localize`:@@yesNor:Yes` : $localize`:@@noNor:No`
      }
      else if (resultData?.type === 'dropdown') {
        if (resultData?.listType.id === 'multiSelect') {
          return uiData[name].map(i => i.name).join(',');
        }
        if (resultData.hasOwnProperty('isMultiSearchSelect')) {
          return uiData[name].map(i => i.name).join(',');
        } else if (!resultData.hasOwnProperty('isMultiSearchSelect')) {
          return uiData[name]?.name;
        }

      } else if (resultData?.type === 'radio') {
        const selectedOption = resultData.options.find(option => option.value === uiData[name]);
        return selectedOption ? this.langTranslator(selectedOption['label']) : this.langTranslator(uiData[name]);
      }
      else {
        return uiData[name];
      }
    }
  }

  /**
   *
   * @param fieldNames Array of fields to be captured.
   * @param formattedArray array to return the captured data.
   * @param index
   * @returns
   */
  pushFieldsWithoutNull({ fieldNames, formattedArray, index }: { fieldNames: string[]; formattedArray: any[]; index?: string }): { name: string; data: any }[] {
    fieldNames.forEach((name) => {
      const data = this.getData(name + index, '', this.step2);
      if (data) {
        formattedArray.push({
          name: this.getData(name + index, 'label', this.step2)['label'],
          value: data,
        });
      }
    });
    return formattedArray;
  }

  buildDetailsWithoutNull({
    mainUIFieldName,
    fieldNames,
    conditionalFieldName,
  }: {
    mainUIFieldName: string;
    fieldNames: string[];
    conditionalFieldName?: string
  }) {

    // array to return
    let formattedArray = [];

    const container = Utils.getFieldFromStructure(
      this.dataStoreService.get(this.step2).uiStructure,
      mainUIFieldName
    )?.fields;
    const uiData = this.dataStoreService.get(this.step2).uiData;
    // loop over fields
    if (container) {
      for (let i = 0; i < container.length; i++) {
        const matches = container[i].name.match(/(\d+)/);
        const digit = matches?.[0];

        // a main if condition that if 'Yes', then do the rest
        if (conditionalFieldName) {
          if (uiData[conditionalFieldName] === 'Yes') {
            // array of nested fields to look for
            // loop over nested fields
            formattedArray = this.pushFieldsWithoutNull({ fieldNames, formattedArray, index: digit ? digit : '' });
          }
        } else {
          formattedArray = this.pushFieldsWithoutNull({ fieldNames, formattedArray, index: digit ? digit : '' });
        }
      }
    }
    // the main data
    // return array
    return formattedArray;
  }

  /**
   * Reusable method to capture the data.
   * Common for all the countries.
   * @param data Radio button condition name.
   * @returns Array
   */
  captureData(data) {
    const personalAccidentDetails = Array.isArray(data) ? data : [data];
    let personalAccidentDetailsInfo = [];
    personalAccidentDetailsInfo = this.pushFieldsWithoutNull({ fieldNames: personalAccidentDetails, formattedArray: personalAccidentDetailsInfo, index: '' });
    return personalAccidentDetailsInfo;
  }

  fractureList(e) {
    let obj = {};
    if (this.getData(e, '', this.step2)) {
      obj = {
        'name': this.getData(e, 'label', this.step2)['label'],
        'value': this.getData(e, '', this.step2)
      }
    }
    return obj;
  }

  /**
   * This function will be used when getting the amount Value.
   * @param field
   * @param index
   * @param step
   * @returns
   */
  checkCustom(field, index, step, axisPipe) {
    if (this.getData(field + index, 'label', step)['type'] === 'custom' &&
      this.getData(field + index, 'label', step)['element'] === 'CurrencyDropdownComponent') {
      return this.getData(field + index, '', step)['phoneNumber'] ?
        this.getData(field + index, '', step)['phoneCode'].hasOwnProperty('label') ?
          this.getData(field + index, '', step)['phoneCode']['label'] + ' ' + axisPipe.transform(this.getData(field + index, '', step)['phoneNumber'].toString(), this.mySettings51) :
          this.getData(field + index, '', step)['phoneCode'] + ' ' + axisPipe.transform(this.getData(field + index, '', step)['phoneNumber'].toString(), this.mySettings51)
        : null
    }
    else {
      return this.getData(field + index, '', step);
    }
  }

  /**
   * This function will be used in the Treatment Cost Table.
   * @param num
   * @param locale
   * @returns
   */
  decimalConverter(num: string, locale: string): string {
    const convert2Num: number = parseFloat(num);
    const decimalNum = convert2Num.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    if (decimalNum.substring(decimalNum.length - 3)[0] === ',') {
      const decimalNumber = decimalNum.replace(decimalNum.substring(decimalNum.length - 3)[0], '.');
      return decimalNumber;
    } else {
      return decimalNum;
    }
  }

  // PA sections start's here

  /**
   * Personal Accident icon
   * @returns
   */
  personalAccidentPayload() {
    let personalPayLoad = [];
    let hospitalDocInfoIsPresent = false;
    personalPayLoad = personalPayLoad.concat(this.getPersonalAccident());
     this.personalAccident.forEach(res => {
      const country = this.cacheService.getCountry();
      const amrValue = countrySpecificAMR[country] ? countrySpecificAMR[country].amr : 'Accident Medical Reimbursement/ Daily Hospital Income/ Fracture or Dislocation';
      if (res === amrValue) {
        // Generated by AIG Copilot - start
        /**
         * Object-based conditional item approach for handling fracture/dislocation data
         * 
         * This approach uses an array of configuration objects instead of direct conditional arrays.
         * Benefits:
         * 1. More readable and maintainable than ternary operators with arrays
         * 2. Easily extensible for multiple conditional items
         * 3. Separates condition logic from data generation
         * 4. Provides clear structure for complex conditional logic
         */
        const fractureOrDislocationItems = [
          {
            // Condition: Include fracture/dislocation data only if NOT required to be excluded for this country
            condition: !isFractureNotRequired[country]?.fracture,
            // Data: The actual payload data to include when condition is true
            data: this.featureOrDisclosedPdf()
          }
          // Additional conditional items can be easily added here following the same pattern
        ]
        .filter(item => item.condition)  // Remove items where condition is false
        .map(item => item.data);         // Extract only the data from remaining items
        // Generated by AIG Copilot - end

        // Concatenate all required sections with conditionally included fracture/dislocation items
        personalPayLoad = personalPayLoad.concat(this.accidentalMedical("a"), this.dailyHospitalIncome('a'), this.getCreditTravel("a"), ...fractureOrDislocationItems);
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Medical Leave Benefit') {
        personalPayLoad = personalPayLoad.concat(this.mediaclLeave('a'), this.detailsMedicalLeave());
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Permanent/Temporary Disablement') {
        personalPayLoad = personalPayLoad.concat(this.PermanentDisablement('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Accidental Death') {
        personalPayLoad = personalPayLoad.concat(this.accidentalDeath('a'));
        hospitalDocInfoIsPresent = true;
      }
      const otherValue = countrySpecificHeadings[country] ? countrySpecificHeadings[country].other : 'Other';
      if (res === otherValue) {
        personalPayLoad = personalPayLoad.concat(this.otherDeath("a"));
      }
    });
    if (hospitalDocInfoIsPresent) {
      personalPayLoad = personalPayLoad.concat(this.hospitalDoctoreInfoPdf());
    }
    return personalPayLoad;
  }

 getPersonalAccident() {
    const personalDetails = [];
    const country = this.cacheService.getCountry();
    const paData = countrySpecificPA[country];
    personalDetails.push(
      {
        name: this.getData('claimBenefits', "label", this.step2)['label'] === "Select Claim Type" ? $localize`:@@What is the cause of your claim?:What is the cause of your claim?` : "",
        value: paData && paData.pa ? paData.pa : this.langTranslator(this.dataStoreService.get(this.step2).uiData['claimBenefits'])
      });
    const arrysub1 = ["heading", "accidentOccurred", "injuriesSustained", "accidentDate", "timeIncident", "accidentLocationLookup", "firstVisit", "diagnosis", "trafficAccident"]
    const arraysub2 = ["heading", "chooseClaimType"];
    const detailsHeading = countrySpecificHeadings[country]? countrySpecificHeadings[country]?.detailsPA : 'Personal Accident Details';
    const benefitsHeading = countrySpecificHeadings[country]? countrySpecificHeadings[country]?.benefitsPA : 'Personal Accident Benefits';
    arrysub1.forEach(key => {
      if (key === 'heading') {
        personalDetails.push(
          {
            name: $localize`:@@Personal Accident Details:${detailsHeading}`,
            value: "heading"
          });
      } else if (key === "accidentLocationLookup") {
        if (this.getData(key, "", this.step2)) {
          personalDetails.push(
            {
              name: this.getData(key, 'label', this.step2)['label'],
              value: this.dataStoreService.checkAutoComplete(this.getData(key + 'val', '', this.step2) ? this.getData(key + 'val', '', this.step2) : this.getData(key, '', this.step2).formatted_address ? this.getData(key, '', this.step2).formatted_address : this.getData(key, '', this.step2))
            }
          );
        }
      } else if (key === 'diagnosis') {
        if (key.indexOf('diagnosis') > -1) {
          personalDetails.push(
            {
              name: this.getData('diagnosis', 'label', this.step2)['label'],
              value: this.getData('diagnosis', '', this.step2),
            }
          );
        }
        if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosis']?.id === '13') {
          personalDetails.push(
            {
              name: this.getData('otherDia', 'label', this.step2)['label'],
              value: this.getData('otherDia', '', this.step2),
            }
          );
        }
      } else {
        if (this.dataStoreService.get(this.step2)?.uiData[key] !== 'diagnosis') {
          if (this.getData(key, '', this.step2)) {
            personalDetails.push(
              {
                name: this.getData(key, 'label', this.step2)['label'],
                value: this.getData(key, '', this.step2)
              }
            );
          }
        }
      }
    });
    arraysub2.forEach(key => {
      if (key === 'heading') {
        personalDetails.push(
          {
            name: $localize`:@@Personal Accident Benefits:${benefitsHeading}`,
            value: "heading"
          })
      } else {
        const newArray = [];
        this.personalAccident = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimType'];
        CHECKBOXLITEPERSONAL.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(this.langTranslator(headingValue));
              this.personalAccident.push(headingValue);
            }
          });
        });
        personalDetails.push(
          {
            name: this.getData(key, 'label', this.step2)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });
    return personalDetails.filter(e => (e.name !== undefined && e.name !== null));
  }

  /**
  *
  * @param e
  * @returns
  */
  accidentalMedical(e?) {
    let DetailsData = [];
    const arraysub4 = ['heading', 'westernMedicine', 'mobileAdd', 'dentalTreatment', 'sum'];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    arraysub4.forEach(key => {
      if (key === 'heading') {
        DetailsData.push(
          {
            name: '',
            value: 'heading'
          }
        );
      } else {
        // Generated by AIG Copilot - start
        const medicalExpenseData = this.dataStoreService.get(this.step2).uiData['medicalExpense'];
        const expenseAmount = medicalExpenseData[key];
        const currency = uiData['medicalExpense'].currency.label;
        const formattedValue = expenseAmount 
          ? `${currency} ${this.customCurrencySeprator(expenseAmount)}`
          : `${currency} ${this.customCurrencySeprator("0.00")}`;
        // Generated by AIG Copilot - end
        
        DetailsData.push(
          {
            name: key === 'westernMedicine' ? $localize`:@@Medical Treatment:Medical Treatment` : key === 'dentalTreatment' ? $localize`:@@Dental Treatment:Dental Treatment` : key === 'mobileAdd' ? $localize`:@@Mobility Aid:Mobility Aid` : key === 'sum' ? $localize`:@@Total Claim Amount:Total Claim Amount` : '',
            value: formattedValue
          }
        );
      
      }
    });
    if (e) {
      if (DetailsData.length > 1) {
        DetailsData[0].value = '';
        const array = [{
          name: $localize`:@@Accident Medical Reimbursement:Accident Medical Reimbursement`,
          value: 'heading'
        }];
        DetailsData = [...array, ...DetailsData];
      }
      else {
        DetailsData = [];
      }
    }
    return DetailsData;
  }

  customCurrencySeprator(value) {
    if (value) {
      const data = this.axisPipe.transform(value.toString(), this.mySettings51);
      return data;
    }
  }

  /**
   *
   * @param data
   * @returns
   */
dailyHospitalIncome(data?) {
    let personalAccidentDetailsInfo = this.captureData('admittedHospital');
    const heading = countrySpecificHeadings[this.cacheService.getCountry()]?.dailyHospitalIncome ?? 'Daily Hospital Income';
    if (data && personalAccidentDetailsInfo.length > 0) {
      personalAccidentDetailsInfo = [{
        name: $localize`:@@Daily Hospital Income:${heading}`,
        value: 'heading'
      }, ...personalAccidentDetailsInfo];
    }
    return personalAccidentDetailsInfo;
  }
  
    getCreditTravel(data?) {
    const nonBagNoEMp = ["nameClinic", "dateOfAdmission", "timeAdmission", "dateOfDischarge", "timeDischarge"];
    let travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: "addTreatmentMain", fieldNames: nonBagNoEMp, conditionalFieldName: "admittedHospital" });
    const hospitalDetails = countrySpecificHeadings[this.cacheService.getCountry()]? countrySpecificHeadings[this.cacheService.getCountry()]?.hospitalDetails : 'Hospitalization Details';

    if (data && travelArr.length > 0) {
      travelArr = [{
        name: $localize`:@@Hospitalization details:${hospitalDetails}`,
        value: "heading"
      }, ...travelArr];
    }
    return travelArr.filter(e => (e.name !== undefined && e.name !== null));
  }

  featureOrDisclosedPdf() {
    const array = [{
      name: $localize`:@@Fracture or Dislocation:Fracture  or Dislocation`,
      value: 'heading'
    }];
    const data = [...array, this.fractureList('sustainFracture'), ...this.featureOrDisclosed(),
    this.fractureList('sustainDislocation'), ...this.siteDisclosed()];
    return data.filter(e => (e.name !== undefined));
  }

  featureOrDisclosed() {
    const nonBagNoEMp = ['siteFracture', 'typeFracture'];
    const travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addFractureMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'sustainFracture' });
    return travelArr.filter(e => (e.name !== undefined && e.name !== '' && e.name !== null));
  }

  siteDisclosed() {
    const nonBagNoEMp = ['siteDislocation'];
    const travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addDislocationMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'sustainDislocation' });
    return travelArr.filter(e => (e.name !== undefined && e.name !== '' && e.name !== null));
  }

  /**
   * For All countries expect UK.
   * @param e
   * @returns
   * PA Medical Leave / Weekly Indemnity starts here.
   */
  mediaclLeave(event?) {
    const travelInsurance = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, `addLeaveMain`).fields;
    let travelArr = [];
     travelInsurance.forEach((card) => {
      card.fields.forEach((data, i) => {
      data?.fields?.forEach((item) => {
        travelArr.push({
          'name': this.getData(item.name, 'label', this.step2)['label'],
          'value': this.getData(item.name, '', this.step2)
        });
      });
    });
    });
    if (event && travelArr.length > 0) {
      const array = [{
        name: $localize`:@@Medical Leave:Medical Leave`,
        value: 'heading'
      }];
      travelArr = [...array, ...travelArr];
    }
    return travelArr.filter(e => (e.name !== undefined && e.name !== '' && e.name !== null));
  }
  // PA Medical Leave / Weekly Indemnity ends here.

  detailsMedicalLeave() {
    const personalAccidentDetails = ['employed', 'dateOfExpected'];
    const personalAccidentDetailsInfo = this.captureData(personalAccidentDetails);
    return personalAccidentDetailsInfo;
  }

  PermanentDisablement(e?) {
    const permanentDi = ['dateOfDisability', 'typeDisability', 'otherCauseDisability'];
    let disabilityData = this.captureData(permanentDi);
    if (e && disabilityData.length > 0) {
      disabilityData = [{
        name: $localize`:@@Permanent/Temporary Disablement:Permanent/Temporary Disablement`,
        value: 'heading'
      }, ...disabilityData];
    }
    return disabilityData;
  }

  accidentalDeath(e?) {
    const permanentDi = ['dateOfDeath', 'localTimePersonal', 'causeDeath', 'autopsy', 'fullName', 'relationName', 'phoneNumberPersonal', 'emailAddress'];
    let disablityData = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    permanentDi.forEach((res) => {
      if (res === 'phoneNumberPersonal') {
           disablityData.push(
            {
              'name': $localize`:@@Phone Number:Phone Number`,
              'value': this.phoneNumberValidation('phoneNumberPersonal')
            }
          );
      } else if (res === 'autopsy') {
        if (uiData['autopsy'] === 'No' && uiData['autopsy'] !== null) {
          disablityData.push(
            {
              name: this.getData('autopsy', 'label', this.step2)['label'],
              value: this.getData('autopsy', '', this.step2),
            },
            {
              name: this.getData('reason', 'label', this.step2)['label'],
              value: this.getData('reason', '', this.step2),
            }
          );
        } else {
          disablityData.push({
            name: this.getData('autopsy', 'label', this.step2)['label'],
            value: this.getData('autopsy', '', this.step2),
          }
        );
        }
      } else {
          disablityData.push(
            {
              name: this.getData(res, 'label', this.step2)['label'],
              value: this.getData(res, '', this.step2)
            }
          );
      }
    });

    if (e && disablityData.length > 0) {
      const array = [{
        name: $localize`:@@Accidental Death Details:Accidental Death Details`,
        value: 'heading'
      }];
      disablityData = [...array, ...disablityData];
    }
    return disablityData;
  }

  /**
   * PA Other section common for all countries.
   * @param e
   * @returns
   * PA Other section starts here.
   */
  otherDeath(e?) {
  let obj;
  const data = this.getData(`claimOther`, "", this.step2);
  if (data) {
    obj = {
      "name": this.getData(`claimOther`, "label", this.step2)['label'],
      "value": data
    }
  }
  if (e && obj) {
    const country = this.cacheService.getCountry();
    const headingName = countrySpecificHeadings[country] ? countrySpecificHeadings[country].other : 'Other';
    const array = [{
      name: $localize`:@@Other:${headingName}`,
      value: "heading"
    }];
    obj = [...array, obj]
  }
  return obj
}
  // PA Other section ends here.

  /**
   * For All the countries to capture Hospital and doctor information in PA
   * @returns
   * Hospital and Doctor Information section starts here.
   */
  hospitalDoctoreInfoPdf() {
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if ((uiData[`doctorInfo`] === 'Yes' || uiData[`doctorInfo`] === 'No') && !countriesWithoutHospitalDoctoreSection.includes(this.cacheService.getCountry())) {
      const array = [{
        name: $localize`:@@Hospital and Doctor Information:Hospital and Doctor Information`,
        value: 'heading'
      }];
      const data = [...array, ...this.captureData(`doctorInfo`), ...this.hospitalDocInfo('a')];
      return data;
    }
  }

  hospitalDocInfo(e?) {
    let travelArr = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (uiData[`doctorInfo`] === 'Yes' && !countriesWithoutHospitalDoctoreSection.includes(this.cacheService.getCountry())) {
      const travelInsurance = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, `addDoctorMain`).fields;
      travelInsurance.forEach((card) => {
        card.fields.forEach((data, i) => {
        if (i > 0 && !event) {
          travelArr.push({
            'name': '',
            'value': ''
          });
        }
        data?.fields?.forEach((item) => {
          if (item.name.match(`mobileDoctor`)) {
            travelArr.push(
              {
                'name': $localize`:@@Phone Number:Contact Number`,
                'value': uiData[item.name]?.phoneNumber?.length > 0 ? this.getData(item.name, '', this.step2)['phoneCode'].hasOwnProperty('label') ? this.getData(item.name, '', this.step2)['phoneCode']['label'] + '-' + this.getData(item.name, '', this.step2)['phoneNumber'] : this.getData(item.name, '', this.step2)['phoneCode'] + '-' + this.getData(item.name, '', this.step2)['phoneNumber'] : ''
              }
            );
          }
          else {
            travelArr.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.getData(item.name, '', this.step2)
            });
          }
        });
      });
      });
    } else {
      travelArr = [];
    }
    return travelArr.filter(data => (data.name !== undefined && data.name !== '' && data.name !== null));
  }

  drInfor() {
    const personalAccidentDetailsInfo = this.captureData('doctorInfo');
    return personalAccidentDetailsInfo;
  }
  // Hospital and Doctor Information section ends here.

  // PA sections end's here

  // TA sections start's here

  /**
 * Travel icon from step 2
 * @param step
 * @returns
 */
  getTravelDetails(step) {
    const travelDetailsInfo = [];
    travelDetailsInfo.push(
      {
        name: this.getData('claimBenefits', 'label', step)['label'] === 'Select Claim Type' ? $localize`:@@What is the cause of your claim?:What is the cause of your claim?` : '',
        value: this.langTranslator(this.dataStoreService.get(this.step2).uiData['claimBenefits'])
      }
    );
    const travelInfo = ['heading', 'dateSymptom', 'dateVisit', 'diagnosisIllness',];
    const uiData = this.dataStoreService.get(step).uiData;
    travelInfo.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Travel Details:Travel Details`,
            value: 'heading'
          }
        );
      } else {
        if (fieldName === 'diagnosisIllness' && fieldName.indexOf('diagnosisIllness') > -1) {
          travelDetailsInfo.push(
            {
              name: this.getData('diagnosisIllness', 'label', step)['label'],
              value: this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisIllness']?.name
            }
          );
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step)
            }
          );
        }
      }
    });

    const travelBenefit = ['heading', 'chooseClaimTypeIllness'];
    travelBenefit.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Travel Benefits:Travel Benefits`,
            value: 'heading'
          }
        );
      }
      else {
        const newArray = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'];
        CHECKBOXHEADINGLITETravel.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(this.langTranslator(headingValue));
              this.personalAccident.push(headingValue);
            }
          });
        });
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingIncident') !== undefined) {
      travelDetailsInfo.push(...this.claimingIncident(step, uiData));
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingDelayed') !== undefined) {
      travelDetailsInfo.push(...this.claimingDelayed(step));
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingTrip') !== undefined) {
      travelDetailsInfo.push(...this.claimingTrip(step));
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingLost') !== undefined) {
      travelDetailsInfo.push(...this.claimingLost(step, uiData));
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingOther') !== undefined) {
      travelDetailsInfo.push(...this.claimingOther(step));
    }
    return travelDetailsInfo.filter(e => (e.name !== undefined && e.name !== null));
  }

  claimingIncident(step, uiData) {
    const travelDetailsInfo = [];
    const travelBenefitType = ['heading', 'injuredSick'];
    travelBenefitType.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Medical Incident:Medical Incident`,
            value: 'heading'
          }
        );
      } else {
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: this.dataStoreService.get('fnol-claimtype-details').uiData['injuredSick'] === 'wasInjured' ? $localize`:@@I was injured:I was injured` : $localize`:@@I was sick:I was sick`,
          }
        );
      }
    });

    if (uiData['injuredSick'] === 'wasInjured' && uiData['injuredSick'] !== null) {
      const insurance = ['claimDescribeWords', 'whenOccur', 'diagnosisInjured', 'medicalExpenseInjured', 'travelAccident'];
      insurance.forEach(fieldName => {
        if (fieldName === 'medicalExpenseInjured') {
          const medicalDetails = ['westernMedicine', 'mobileAdd', 'dentalTreatment', 'sum'];
          travelDetailsInfo.push(
            {
              name: $localize`:@@Cost of Treatment:Cost of Treatment`,
              value: 'heading'
            }
          );
          
          medicalDetails.forEach(key => {
            // Generated by AIG Copilot - start
            const medicalExpenseInjuredData = this.dataStoreService.get(this.step2).uiData['medicalExpenseInjured'];
            const expenseAmount = medicalExpenseInjuredData[key];
            const currency = uiData['medicalExpenseInjured'].currency.label
            const formattedValue = expenseAmount 
              ? `${currency} ${this.customCurrencySeprator(expenseAmount)}`            
              : `${currency} ${this.customCurrencySeprator("0.00")}` 
            // Generated by AIG Copilot - end
            
            travelDetailsInfo.push(
              {
                name: key === 'westernMedicine' ? $localize`:@@Medical Treatment:Medical Treatment` : key === 'mobileAdd' ? $localize`:@@Mobility Aid:Mobility Aid` : key === 'dentalTreatment' ? $localize`:@@Dental Treatment:Dental Treatment` : key === 'sum' ? $localize`:@@Total Claim Amount:Total Claim Amount` : '',
                value: formattedValue
              }
            );
          });
        }

        if (fieldName === 'diagnosisInjured') {
          if (fieldName.indexOf('diagnosisInjured') > -1) {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisInjured', 'label', step)['label'],
                value: this.getData('diagnosisInjured', '', step),
              }
            );
          }
          if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisInjured']?.id === '8') {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisOther', 'label', step)['label'],
                value: this.getData('diagnosisOther', '', step),
              }
            );
          }
        }

        if (fieldName === 'travelAccident') {
          if (uiData['travelAccident'] === 'Yes' && uiData['travelAccident'] !== null) {
            travelDetailsInfo.push(
              {
                name: this.getData('travelAccident', 'label', step)['label'],
                value: this.getData('travelAccident', '', step),
              },
              {
                name: this.getData('claimDescribe', 'label', step)['label'],
                value: this.getData('claimDescribe', '', step),
              },
              {
                name: this.getData('nameCost', 'label', step)['label'],
                value: this.checkCustom('nameCost', '', step, this.axisPipe),
              }
            );
          } else {
            travelDetailsInfo.push({
              name: this.getData('travelAccident', 'label', step)['label'],
              value: this.getData('travelAccident', '', step),
            });
          }
        } else {
          if (fieldName !== 'medicalExpenseInjured' && fieldName !== 'diagnosisInjured') {
            travelDetailsInfo.push({
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            });
          }
        }
      });
    } else if (uiData['injuredSick'] === 'wasSick' && uiData['injuredSick'] !== null) {
      const insurance = ['claimDescribeWordsSick', 'whenOccurSick', 'diagnosisSickInjuredSick', 'medicalExpenseSick', 'travelAccidentSick'];
      insurance.forEach(fieldName => {
        if (fieldName === 'medicalExpenseSick') {
          const medicalDetails = ['heading', 'westernMedicine', 'mobileAdd', 'dentalTreatment', 'sum'];
          medicalDetails.forEach(key => {
            if (key === 'heading') {
              travelDetailsInfo.push(
                {
                  name: $localize`:@@Cost of Treatment:Cost of Treatment`,
                  value: 'heading'
                }
              );
            } else {
              // Generated by AIG Copilot - start
              const medicalExpenseSickData = this.dataStoreService.get(this.step2).uiData['medicalExpenseSick'];
              const expenseAmount = medicalExpenseSickData[key];
              const currency = uiData['medicalExpenseSick'].currency.label;
              const formattedValue = expenseAmount 
                ? `${currency} ${this.customCurrencySeprator(expenseAmount)}`            
                : `${currency} ${this.customCurrencySeprator("0.00")}`;
              // Generated by AIG Copilot - end
              
              travelDetailsInfo.push(
                {
                  name: key === 'westernMedicine' ? $localize`:@@Medical Treatment:Medical Treatment` : key === 'mobileAdd' ? $localize`:@@Mobility Aid:Mobility Aid` : key === 'dentalTreatment' ? $localize`:@@Dental Treatment:Dental Treatment` : key === 'sum' ? $localize`:@@Total Claim Amount:Total Claim Amount` : '',
                  value: formattedValue
                }
              );
            }
          });
        }

        if (fieldName === 'diagnosisSickInjuredSick') {
          if (fieldName.indexOf('diagnosisSickInjuredSick') > -1) {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisSickInjuredSick', 'label', step)['label'],
                value: this.getData('diagnosisSickInjuredSick', '', step),
              }
            );
          }
          if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickInjuredSick']?.id === '13') {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisSickOtherSick', 'label', step)['label'],
                value: this.getData('diagnosisSickOtherSick', '', step),
              }
            );
          }
        }

        if (fieldName === 'travelAccidentSick') {
          if (uiData['travelAccidentSick'] === 'Yes' && uiData['travelAccidentSick'] !== null) {
            travelDetailsInfo.push(
              {
                name: this.getData('travelAccidentSick', 'label', step)['label'],
                value: this.getData('travelAccidentSick', '', step),
              },
              {
                name: this.getData('claimDescribeSick', 'label', step)['label'],
                value: this.getData('claimDescribeSick', '', step),
              },
              {
                name: this.getData('nameCostSick', 'label', step)['label'],
                value: this.checkCustom('nameCostSick', '', step, this.axisPipe),
              }
            );
          } else {
            travelDetailsInfo.push({
              name: this.getData('travelAccidentSick', 'label', step)['label'],
              value: this.getData('travelAccidentSick', '', step),
            });
          }
        } else {
          if (fieldName !== 'medicalExpenseSick' && fieldName !== 'diagnosisSickInjuredSick') {
            travelDetailsInfo.push({
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            });
          }
        }
      });
    }
    return travelDetailsInfo;
  }
  claimingDelayed(step) {
    const travelDetailsInfo = [];
    const travelBenefitType = ['heading', 'originalFlightNumber', 'originalArriveDate', 'originalArriveTime', 'revisedFlightNumber', 'actualArriveDate', 'actualArriveTime', 'flightDelayed'];
    travelBenefitType.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Delayed Flight:Delayed Flight`,
            value: 'heading'
          }
        );
      } else {
        if (fieldName === 'flightDelayed') {
          if (fieldName.indexOf('flightDelayed') > -1) {
            travelDetailsInfo.push(
              {
                name: this.getData('flightDelayed', 'label', step)['label'],
                value: this.getData('flightDelayed', '', step),
              }
            );
          }
          if (this.dataStoreService.get('fnol-claimtype-details').uiData['flightDelayed'].id === '7') {
            travelDetailsInfo.push(
              {
                name: this.getData('provideDetailsTravel', 'label', step)['label'],
                value: this.getData('provideDetailsTravel', '', step),
              }
            );
          }
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            }
          );
        }
      }
    });
    return travelDetailsInfo;
  }

  claimingTrip(step) {
    const travelDetailsInfo = [];
    const travelBenefitType = ['heading', 'diagnosisSickTripSick', 'diagnosisSickTripShip', 'diagnosisTripOtherShip', 'claimingForOther', 'dateOfCancellation', 'flightExpense', 'flightRefund', 'accommodationExpense', 'accommodationRefund', 'otherTransportationExpense', 'otherTransportationRefund'];
    travelBenefitType.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Cancelled Trip:Cancelled Trip`,
            value: 'heading'
          }
        );
      } else {
        if (fieldName === 'flightExpense' || fieldName === 'flightRefund' || fieldName === 'accommodationExpense' || fieldName === 'accommodationRefund' || fieldName === 'otherTransportationExpense' || fieldName === 'otherTransportationRefund') {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.checkCustom(fieldName, '', step, this.axisPipe)
            }
          );
        }

        if (fieldName === 'diagnosisSickTripSick') {
          travelDetailsInfo.push(
            {
              name: this.getData('diagnosisSickTripSick', 'label', step)['label'],
              value: this.getData('diagnosisSickTripSick', '', step),
            }
          );
          const diagnosisSickTripSick = this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripSick'];
          if (diagnosisSickTripSick.id === '7') {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisTripOtherSick', 'label', step)['label'],
                value: this.getData('diagnosisTripOtherSick', '', step),
              }
            );
          }

          if (diagnosisSickTripSick.id === '4') {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisSickTripShip', 'label', step)['label'],
                value: this.getData('diagnosisSickTripShip', '', step),
              }
            );
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripShip']?.id === '8') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisTripOtherShip', 'label', step)['label'],
                  value: this.getData('diagnosisTripOtherShip', '', step),
                }
              );
            }
          }
        }

        if (fieldName === 'claimingForOther' || fieldName === 'dateOfCancellation') {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            }
          );
        }
      }
    });
    return travelDetailsInfo;
  }

  claimingLost(step, uiData) {
    const travelDetailsInfo = [];
    const travelBenefitType = ['heading', 'itemClaimType'];
    travelBenefitType.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Baggage / Item Claim:Baggage / Item Claim`,
            value: 'heading'
          }
        );
      } else {
        const newArray = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'];
        CHECKBOXLITEBAG.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const headingValue = field.heading;
              newArray.push(this.langTranslator(headingValue));
            }
          });
        });
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: newArray.join(', '),
          }
        );
      }
    });

    const travelBagsDetails = ['travelBags'];
    travelBagsDetails.forEach(fieldName => {
      if (fieldName === 'travelBags') {
        travelDetailsInfo.push(
          {
            name: this.getData('travelBags', 'label', step)['label'],
            value: this.langTranslator(this.getData('travelBags', '', step)),
          }
        );
        if (uiData['travelBags'] === 'Delayed') {
          const delayedDetails = ['landDate', 'timeLand', 'returnedDate', 'timeReturned'];
          delayedDetails.forEach(fieldsName => {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldsName, 'label', step)['label'],
                value: this.getData(fieldsName, '', step),
              }
            );
          });
        }

        if (uiData['travelBags'] === 'Damaged') {
          const delayedDetails = ['bagsTripSick', 'damagedDate', 'provideDetails', 'heading'];
          delayedDetails.forEach(delayedDetail => {
            if (delayedDetail === 'heading') {
              travelDetailsInfo.push(
                {
                  name: $localize`:@@Bags and/or Items Details:Bags and/or Items Details`,
                  value: 'heading'
                }
              );
            } 
            if (delayedDetail === 'bagsTripSick') {
              if (delayedDetail.indexOf('bagsTripSick') > -1) {
                travelDetailsInfo.push(
                  {
                    name: this.getData('bagsTripSick', 'label', step)['label'],
                    value: this.getData('bagsTripSick', '', step),
                  }
                );
              }
              if (this.dataStoreService.get('fnol-claimtype-details').uiData['bagsTripSick'].id === '3') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('otherBagsTripSick', 'label', step)['label'],
                    value: this.getData('otherBagsTripSick', '', step),
                  }
                );
              }
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData(delayedDetail, 'label', step)['label'],
                  value: this.getData(delayedDetail, '', step),
                }
              );
            }
          });

          if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' || ((this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myItems') || (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems'))) {
            const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(step).uiStructure, 'addItemsMain').fields;
            let tempArray = [];
             bagDamage.forEach((card) => {
            card.fields.forEach((data) => {
              data?.fields?.forEach((item) => {
                if (item.name.match('nameValue') || item.name.match('repairCost')) {
                  if (this.getData(item.name, '', this.step2)) {
                    tempArray.push({
                      'name': this.getData(item.name, 'label', this.step2)['label'],
                      'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                    });
                  }
                } else {
                  if (this.getData(item.name, '', this.step2)) {
                    tempArray.push({
                      'name': this.getData(item.name, 'label', this.step2)['label'],
                      'value': this.getData(item.name, '', this.step2)
                    });
                  }
                }
              });
              // Removed logic that pops items from tempArray to ensure all fields, including repairCost, are shown
              travelDetailsInfo.push(...tempArray);
              tempArray = [];
            });
            });
          } else if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems') {
            const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addItemsMain').fields;
            bagDamage.forEach((card) => {
              card.fields.forEach((data, i) => {
              data?.fields?.forEach((item) => {
                if (item.name.match('nameValue')) {
                  if (this.getData(item.name, '', this.step2)) {
                    travelDetailsInfo.push({
                      'name': this.getData(item.name, 'label', this.step2)['label'],
                      'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                    });
                  }
                } else if (item.name.match('bagItem') || item.name.match('yearPurchased')) {
                  if (this.getData(item.name, '', this.step2)) {
                    travelDetailsInfo.push({
                      'name': this.getData(item.name, 'label', this.step2)['label'],
                      'value': this.getData(item.name, '', this.step2)
                    });
                  }
                }
              });
            });
            });
          }
        }

        if (uiData['travelBags'] === 'Lost or Stolen') {
          const lostStolenDetails = ['stolenLost', 'stolenHappened', 'stolenItem', 'stolenItemWas', 'stolenDate', 'heading'];
          lostStolenDetails.forEach(lostStolenDetail => {
            if (lostStolenDetail === 'heading') {
              travelDetailsInfo.push(
                {
                  name: $localize`:@@Bags and/or Items Details:Bags and/or Items Details`,
                  value: 'heading',
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData(lostStolenDetail, 'label', step)['label'],
                  value: this.getData(lostStolenDetail, '', step),
                }
              );
            }
          });

          const lostStolen = Utils.getFieldFromStructure(this.dataStoreService.get(step).uiStructure, 'addStolenMain').fields;
          lostStolen.forEach((card) => {
          card.fields.forEach((data, i) => {
            const matches = data.name.match(/(\d+)/);
            const index1 = matches != null ? matches[0] : '';
            const stolenDetails = ['bagItemStolen', 'nameStolenValue', 'yearStolenPurchased', 'heading'];
            stolenDetails.forEach((item) => {
              if (item === 'nameStolenValue') {
                travelDetailsInfo.push(
                  {
                    name: this.getData(item + index1, 'label', step)['label'],
                    value: this.checkCustom(item + index1, '', step, this.axisPipe)
                  }
                );
              } else if (item === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: '',
                    value: 'heading'
                  }
                );
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(item + index1, 'label', step)['label'],
                    value: this.getData(item + index1, '', step)
                  }
                );
              }
            });
          });
          });

          if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
            travelDetailsInfo.push(
              {
                name: this.getData('authorityReport', 'label', step)['label'],
                value: this.checkCustom('authorityReport', '', step, this.axisPipe)
              },
              {
                name: this.getData('authorityCopyReport', 'label', step)['label'],
                value: this.checkCustom('authorityCopyReport', '', step, this.axisPipe)
              }
            );
          } else {
            travelDetailsInfo.push(
              {
                name: this.getData('authorityReport', 'label', step)['label'],
                value: this.checkCustom('authorityReport', '', step, this.axisPipe)
              }
            );
          }
          if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
            travelDetailsInfo.push(...this.authorityCont(uiData, step));
          }
        }
      }
    });
    return travelDetailsInfo.filter(e => (e.name !== undefined));
  }

  authorityCont(uiData, step) {
    const copyReport = ['nameAuthority', 'referenceNumber', 'phoneNumber', 'emailStolen', 'myAddressLookup'];
    const travelDetailsInfo = [];
    copyReport.forEach(fieldName => {
      if (fieldName === 'myAddressLookup') {
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: this.dataStoreService.checkAutoComplete(this.getData(fieldName + 'val', '', step) ? this.getData(fieldName + 'val', '', step) : this.getData(fieldName, '', step).formatted_address ? this.getData(fieldName, '', step).formatted_address : this.getData(fieldName, '', step))
          }
        );
      } else if (fieldName === 'phoneNumber' && uiData['phoneNumber'] !== null) {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Phone Number:Phone Number`,
            value: this.phoneNumberValidation('phoneNumber')
          });
      } else {
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: this.checkCustom(fieldName, '', step, this.axisPipe)
          }
        );
      }
    });
    return travelDetailsInfo;
  }

  claimingOther(step) {
    const travelDetailsInfo = [];
    const travelBenefitType = ['heading', 'claimingForOtherFor','travelIncidentDate'];
    travelBenefitType.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: $localize`:@@Other:Other`,
            value: 'heading'
          });
      } else {
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: this.getData(fieldName, '', step),
          }
        );
      }
    });
    return travelDetailsInfo;
  }
  // TA sections end's here


  /**
    * For All countries.
    * @returns getOtherDetails.
    * getOtherDetails section starts here.
    */
  getOtherDetails() {
    const otherDetailsInfo = [];
    otherDetailsInfo.push(
      {
        name: this.getData('claimBenefits', 'label', this.step2)['label'] === 'Select Claim Type' ? $localize`:@@What is the cause of your claim?:What is the cause of your claim?` : '',
        value: this.langTranslator(this.dataStoreService.get(this.step2).uiData['claimBenefits'])
      });
    otherDetailsInfo.push({
      name: this.getData('claimForOther', 'label', this.step2)['label'],
      value: this.getData('claimForOther', '', this.step2)
    });
    otherDetailsInfo.push({
      name: this.getData('otherDate', 'label', this.step2)['label'],
      value: this.getData('otherDate', '', this.step2)
    });
    return otherDetailsInfo;
  }

  langTranslator(data) {
    const translations = this.cacheService.getTranslation()
    if (translations) {
      data = translations[data] ? translations[data] : data;
    }
    return data;
  }

  phoneNumberValidation(controlName) {
    const data = this.dataStoreService.get(this.step2)['uiData'][controlName];
    if(data){
    return data['phoneNumber']&& data.length !== 0 ? this.getData(controlName, '', this.step2)['phoneCode'].hasOwnProperty('label') ? this.getData(controlName, '', this.step2)['phoneCode']['label'] + '-' + this.getData(controlName, '', this.step2)['phoneNumber'] : this.getData(controlName, '', this.step2)['phoneCode'] + '-' + this.getData(controlName, '', this.step2)['phoneNumber'] : '';
    }
  }
}
